import { useMemo } from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import {
  discoveryApiRef,
  fetchApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { JiraBoardPicker } from '../../../components/jira/JiraBoardPicker';
import {
  BoardSelection,
  asSelection,
} from '../../../components/jira/boardSelection';
import { jiraListings } from '../../../components/jira/listings';
import {
  BOARD_LISTING_UNAVAILABLE,
  isListedJiraInstance,
} from '../../../components/jira/presets';
import { jiraInstanceOf, jiraProjectKeyOf } from '../jiraForm';

const ID_PREFIX = 'jira-boards';
const TITLE = 'Jira boards this instance polls';
const REQUIRED_ERROR =
  'Pick at least one board: an instance that polls the whole project takes every squad’s tickets.';

export const JiraBoardsField = (
  props: FieldExtensionComponentProps<BoardSelection>,
) => {
  const { onChange, formData, formContext, rawErrors } = props;
  const discovery = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const listings = useMemo(
    () => jiraListings(discovery, fetchApi),
    [discovery, fetchApi],
  );

  const projectKey = jiraProjectKeyOf(formContext);
  const instance = jiraInstanceOf(formContext);
  const selection = asSelection(formData);
  const error =
    (rawErrors ?? []).length > 0 && selection.filterIds.length === 0
      ? REQUIRED_ERROR
      : undefined;

  return (
    <JiraBoardPicker
      idPrefix={ID_PREFIX}
      title={TITLE}
      projectKey={projectKey}
      selection={selection}
      onChange={onChange}
      listings={listings}
      unavailableReason={
        isListedJiraInstance(instance) ? undefined : BOARD_LISTING_UNAVAILABLE
      }
      autoSelectSoleBoard
      error={error}
    />
  );
};
